export default __webpack_public_path__ + "static/media/apple-icon-180x180.17a4f532.png";